import { render, staticRenderFns } from "./RepeatIntervalCard.vue?vue&type=template&id=10f6ca76"
import script from "./RepeatIntervalCard.vue?vue&type=script&lang=js"
export * from "./RepeatIntervalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports